import { jsxs, jsx } from 'react/jsx-runtime';
import { ErrorMessage } from '@promo-platform/error-message';
import { FieldHead } from '@promo-platform/field-head';
import { useConditionsWatch, parseRegex } from '@promo-platform/utils';
import classNames from 'classnames';
import { useEffect } from 'react';
import { useFormContext } from 'react-hook-form';

const LongTextField = ({ numberOfRows, placeholder, mandatoryValidation, minLengthValidation, maxLengthValidation, patternValidation, id, label, tooltip, tooltipLabel, description, alias, conditions, }) => {
    var _a;
    const { register, unregister, formState: { errors }, watch, } = useFormContext();
    const shouldRender = useConditionsWatch(watch, conditions);
    const regexPattern = parseRegex(patternValidation === null || patternValidation === void 0 ? void 0 : patternValidation.value);
    useEffect(() => {
        if (!shouldRender) {
            unregister(alias);
        }
    }, [shouldRender, unregister, alias]);
    return shouldRender ? (jsxs("div", Object.assign({ className: "pp-long-text-field" }, { children: [jsx(FieldHead, { id: id, label: label, description: description, tooltipText: tooltip, tooltipLabel: tooltipLabel }), jsx("textarea", Object.assign({}, register(alias, {
                required: mandatoryValidation && mandatoryValidation.errorMessage,
                maxLength: maxLengthValidation && {
                    value: maxLengthValidation === null || maxLengthValidation === void 0 ? void 0 : maxLengthValidation.value,
                    message: maxLengthValidation === null || maxLengthValidation === void 0 ? void 0 : maxLengthValidation.errorMessage,
                },
                minLength: minLengthValidation && {
                    value: minLengthValidation === null || minLengthValidation === void 0 ? void 0 : minLengthValidation.value,
                    message: minLengthValidation === null || minLengthValidation === void 0 ? void 0 : minLengthValidation.errorMessage,
                },
                pattern: regexPattern &&
                    patternValidation && {
                    value: regexPattern,
                    message: patternValidation.errorMessage,
                },
            }), { rows: numberOfRows, className: classNames('pp-long-text-field__textarea', {
                    'pp-long-text-field__textarea--error': Boolean(errors === null || errors === void 0 ? void 0 : errors[alias]),
                }), id: id, placeholder: placeholder })), jsx(ErrorMessage, { message: (_a = errors[alias]) === null || _a === void 0 ? void 0 : _a.message })] }))) : null;
};

export { LongTextField };
